import React from "react";
import UserLayout from "../../components/Layout/UserLayout";
import InnerHero from "../../components/InnerHero";
import Section2 from "../../components/Section2";
import CustomCategory from "../../components/CustomCategory";
import SecondCustomBanner from "../../components/SecondCustomBanner";
import FirstCustomBanner from "../../components/FirstCustomBanner";
import PublishBook from "../../components/PublishBook";
import Testimonial from "../../components/Testimonial";
import CustomPublication from "../../components/CustomPublication";
import Faq from "../../components/Faq";
import GetTouch from "../../components/GetTouch";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { Link} from "react-router-dom";
import { Helmet } from "react-helmet";

import { child1, child2, childrenIllustrationImg2, cover1, cover2, cover3, cover4, cover5, cover6, cover7, illustrationImg2, illustrationImg22 } from "../../asserts/images";

const Illustration = () => {
  return (
    <>

    <Helmet>
            <meta charSet="utf-8" />
            <title>
            Childrens Book And Illustrations | Creative Book Experts
            </title>
            <meta
              name="description"
              content="Discover expert childrens book and illustrations at Falcon Book Writing. Our writers and illustrators create magical books that captivate kids everywhere."
            />
            <meta name="keywords" content="Childrens Book And Illustrations" />
            <link rel="canonical" href={window.location.href} />
          </Helmet>


      <UserLayout>
        <InnerHero
          innerheroclass="illustrationBg"
          title="Expert"
          subtitle=" Children’s Book Editing "
          title2="for Memorable, Engaging Tales"
          para="Ensure your children’s stories sparkle with expert editing. Every word, sentence, and illustration is carefully refined to create engaging, memorable tales that captivate young readers, inspire imagination, and leave a lasting impression."
          image={childrenIllustrationImg2}
        />

        <Section2
          innerSec2Class="innerbrilliant_mind_section"
          title="Shaping Magical Stories That Delight  "
          subtitle=" Young Readers "
          // subtitle1="How we work?"
          description="Creating a children’s book is about more than words on a page, it’s about sparking imagination and joy. Our expert editing ensures every story flows smoothly, characters are vibrant, and plots are engaging, keeping young readers captivated from beginning to end. We focus on clarity, pacing, and age-appropriate language, making sure each sentence resonates while preserving the author’s unique voice. From playful dialogue to enchanting descriptions, every element is carefully refined to enhance readability and excitement. Illustrations, chapter structure, and story rhythm are also reviewed to create a cohesive, magical experience. With professional children’s book editing, your manuscript transforms into a polished, immersive tale that delights, inspires, and entertains, leaving young readers eagerly turning pages and falling in love with your story."
          // subtitle2="    Tailored Collaborations?"
          // subtitle3="  Expert Guidance"
          image={illustrationImg22}
          imgClass="illustrationImg2"
          actions={true}
          btn1="Let’s Get Start"
          btn2="Call Us Now"
        />

        <div className="childillus">
          <img className="child1" src={child1}/>
          <CustomCategory className="category_section2" />
        </div>

          <FirstCustomBanner />
        


        <PublishBook />

        <div className="childillus2">
          <img className="child2" src={child2}/>
          <Testimonial />
        </div>


        <SecondCustomBanner />
        <CustomPublication />


        <section className="portfolio__sec childbookport">
        <div className="container-fluid">
        <div className="row">
            <div className="col-md-12">
                <div className="sec_title">
                <h2>
                    OUR STANDARD <span class="color-red">SPEAKS IN</span> <br />
                    <span class="color-red"> PORTFOLIO</span>
                    </h2>
                </div>
            </div>
            <div className='col-md-12'>
                <Swiper
                    loop={true}
                    // centeredSlides={true}
                    slidesPerView={4}
                    spaceBetween={10}
                    autoplay={{
                        delay: 1,
                        disableOnInteraction: false,
                    }}
                    speed={4000}
                    breakpoints={{
                        1024: { slidesPerView: 4, spaceBetween: 10 },
                        800: { slidesPerView: 3, spaceBetween: 10, centeredSlides: false },
                        600: { slidesPerView: 2, spaceBetween: 10, centeredSlides: false },
                        320: { slidesPerView: 1, spaceBetween: 10, centeredSlides: false },
                    }}
                    modules={[Autoplay]}
                    className="mySwiper"
                >
                    <SwiperSlide>
                        <img src={cover1} alt="Portfolio 1" className="bookportfolio_imgs" />
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={cover2} alt="Portfolio 2" className="bookportfolio_imgs" />
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={cover3} alt="Portfolio 3" className="bookportfolio_imgs" />
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={cover4} alt="Portfolio 4" className="bookportfolio_imgs" />
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={cover5} alt="Portfolio 5" className="bookportfolio_imgs" />
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={cover6} alt="Portfolio 5" className="bookportfolio_imgs" />
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={cover7} alt="Portfolio 5" className="bookportfolio_imgs" />
                    </SwiperSlide>
                </Swiper>
            </div>
            <div class="inner-btn-group">
                  <button className="btn-bg-white blink">
                    <Link to={'/contact-us'}>Get Started</Link>
                  </button>
                  <button className="btn-bg-red"><a href="tel:(855) 408-6509">Call Us Now</a></button>
                </div>
        </div>
        </div>
    </section>


        <Faq />
        <GetTouch />
      </UserLayout>
    </>
  );
};

export default Illustration;
